import i18next from '@bonanza-social/i18n';
import en from './en.json';
import fr from './fr.json';

i18next.addResources('en', 'promos', en);
i18next.addResources('fr', 'promos', fr);

declare global {
  interface RegisteredLocales {
    promos: typeof en;
  }
}
